import { assertValue } from '@shared/helpers'
import { SecLoanAttachment, SecLoansFileCategory } from '@shared/sec-loans'
import type { FileObject } from '@ui-components/types'
import { v4 as uuidv4 } from 'uuid'

export const getFileObjectsFromSecLoanAttachments = (
  fileIds: string[] | undefined,
  secLoanAttachments: SecLoanAttachment[] | undefined,
  category: SecLoansFileCategory,
): FileObject[] => {
  if (
    fileIds === undefined ||
    fileIds.length <= 0 ||
    secLoanAttachments === undefined ||
    secLoanAttachments.length <= 0
  ) {
    return []
  }

  return secLoanAttachments
    .filter((attachment) => fileIds.includes(attachment.fileId) && attachment.category === category)
    .map((attachment) => {
      return {
        id: uuidv4(),
        fileId: attachment.fileId,
        name: assertValue(attachment?.fileName, 'attachment.fileName'),
        size: assertValue(attachment?.size, 'attachment.size'),
        isValid: true,
        uploadProgress: 100,
      } satisfies FileObject
    })
}
